<template>
    <div>
    <div class="con_table period">
        <div class="table_header">
          <div class="name">同期论坛</div>
          <div class="place">会议地点</div>
          <div class="time">会议时间</div>
        </div>
        <ul>
          <li>
            <div class="name">2023第十二届CMF高峰论坛</div>
            <div class="place">1号会议室</div>
            <div class="time">11.15上午</div>
          </li>
          <li>
            <div class="name">新品发布会及供需对接大会</div>
            <div class="place">1号会议室</div>
            <div class="time">11月16日上午</div>
          </li>
          <li>
            <div class="name">2024-2025CMF趋势发布及主题展</div>
            <div class="place">Cmf趋势展专区</div>
            <div class="time">11.15-11.17</div>
          </li>
          <li>
            <div class="name">寻材问料®粉丝线下互动主题展</div>
            <div class="place">寻材问料•展区</div>
            <div class="time">11.15-11.17</div>
          </li>
           <li>
            <div class="name">CEO晚宴</div>
            <div class="place">酒店</div>
            <div class="time">11.15晚18:00</div>
          </li>
           <li>
            <div class="name">最佳CMF评选及颁奖——最佳设计师</div>
            <div class="place">CEO晚宴酒店</div>
            <div class="time">11.15晚18:00</div>
          </li>
           <li>
            <div class="name">最佳CMF评选及颁奖一最佳设计机构</div>
            <div class="place">CEO晚宴酒店</div>
            <div class="time">11.15晚18:00</div>
          </li>
          <li>
            <div class="name">最佳CMF评选及颁奖——人气展商</div>
            <div class="place">CEO晚宴酒店</div>
            <div class="time">11.15晚18:00</div>
          </li>
        </ul>
      </div> 
      <!-- <div class="con_table period" style="margin-top:100px">
        <div class="table_header">
          <div class="name" style="width:100%;padding-left:0;text-align:center">同期特色活动</div>
        </div>
        <ul>
          <li>
            <div class="name" style="width:100%;padding-left:0;text-align:center">2022（第六届）中国好材料颁奖盛典</div>
          </li>
           <li>
            <div class="name" style="width:100%;padding-left:0;text-align:center">新材料产业明星领袖</div>
          </li>
           <li>
            <div class="name" style="width:100%;padding-left:0;text-align:center">新材料产业明星企业</div>
          </li>
          <li>
            <div class="name" style="width:100%;padding-left:0;text-align:center">CMF最具人气展商</div>
          </li>
           <li style="border-bottom:none">
            <div class="name" style="width:100%;padding-left:0;text-align:center;">寻材问料®粉丝线下互动主题展</div>
          </li>
        </ul>
      </div>  -->
    </div>
</template>
<script>
export default {

}
</script>

<style>

</style>